export enum ZIndex {
    MODAL = 1000,
    SELECT_PORTAL = 1001,
    TOOLTIP
}
